import { FunctionComponent } from "react";

import "../App.css";

const Spinner: FunctionComponent = () => {
  return <div className="Spinner"></div>;
};

export default Spinner;
